module.exports = __webpack_public_path__ + "img/hr-red-pita-00.064334b6.png";